import { KeyboardArrowUp, KeyboardArrowDown } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import { DataRow } from 'components/basics/DataRow';
import { NestedContentWrapper } from 'components/basics/NestedContentWrapper';
import { SubmodelDetailList } from 'components/composits/aas-viewer/submodel/SubmodelDetailList';
import { messages } from 'i18n/localization';
import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Submodel } from 'api/v3/aas_core_meta/types';

export function ExpandableDefaultSubmodelDisplay(props: { submodel: Submodel }) {
    const [isExpanded, setIsExpanded] = useState(false);
    return props.submodel.submodelElements && props.submodel.submodelElements.length ? (
        <DataRow title="All available data" hasDivider={true}>
            <Box>
                <Button
                    variant="outlined"
                    startIcon={isExpanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                    sx={{ my: 1 }}
                    onClick={() => setIsExpanded(!isExpanded)}
                    data-testid="submodel-dropdown-button"
                >
                    <FormattedMessage
                        {...messages.mnestix.showEntriesButton[isExpanded ? 'hide' : 'show']}
                        values={{ count: props.submodel.submodelElements.length }}
                    />
                </Button>
                {isExpanded && (
                    <NestedContentWrapper>
                        <SubmodelDetailList
                            submodelId={props.submodel.id}
                            submodelElements={props.submodel.submodelElements}
                        />
                    </NestedContentWrapper>
                )}
            </Box>
        </DataRow>
    ) : (
        <></>
    );
}
